import IntlPhoneInput from "./IntlPhoneInput";

export default IntlPhoneInput;
